import { SxProps } from '@mui/material';

const searchContainer: SxProps = {
  width: '100%',
  height: '100%',
  flexDirection: 'column'
};

const conversationRelativeContainer: SxProps = {
  flex: 1,
  position: 'relative',
  height: '100%'
};

const conversationHeader: SxProps = {
  pt: '20px',
  px: '20px'
};

const conversationContainer: SxProps = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  pt: '10px',
  pb: '30px',
  px: '20px',
  overflowY: 'auto',
  gap: '25px'
};

const conversationUserMessage: SxProps = {
  maxWidth: '320px',
  width: 'fit-content',
  py: '10px',
  px: '14px',
  backgroundColor: 'customGrey.light',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '26px',
  borderRadius: '8px 0px 8px 8px',
  alignSelf: 'flex-end'
};

const conversationAgentMessage: SxProps = {
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '26px',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
  '& .MuiChip-root': {
    verticalAlign: 'middle',
    margin: '0 2px'
  },
  '& a': {
    verticalAlign: 'baseline'
  }
};

const conversationAgentMessageActions: SxProps = {
  alignSelf: 'flex-start',
  mt: 0.5
};

// A quiet indent rule rather than a filled panel: the quoted query is context
// for the sentence above it, not the point of the message. No background, a
// hairline rule, and secondary text so it recedes.
//
// `customGrey.medium` rather than `divider` -- divider is customGrey.dark
// (#28272C) in this theme, which would draw a near-black bar.
const conversationBlockquote: SxProps = {
  display: 'block',
  // The rule is inset from the message's left edge, not flush with it: the
  // quote reads as nested under the sentence above rather than as a sibling.
  m: '8px 0 8px 20px',
  pl: '16px',
  py: '2px',
  borderLeft: '1px solid',
  borderColor: 'customGrey.medium',
  color: 'text.secondary',
  whiteSpace: 'pre-wrap'
};

const loadingLabel = (visible: boolean, fadeMs: number): SxProps => ({
  opacity: visible ? 1 : 0,
  transition: `opacity ${fadeMs}ms ease-in-out`
});

const conversationInputContainer: SxProps = {
  pt: '10px',
  pb: '20px',
  px: '20px',
  gap: '12px'
};

const conversationInputHeader: SxProps = {
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '25px',
  color: 'customGrey.dark',
  pr: '30px'
};

const conversationInputSubheader: SxProps = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  color: 'customGrey.dark',
  pr: '30px'
};

export const candidateProfileSearchConversationSx = {
  searchContainer,
  conversationHeader,
  conversationRelativeContainer,
  conversationContainer,
  conversationUserMessage,
  conversationAgentMessage,
  conversationAgentMessageActions,
  conversationBlockquote,
  conversationInputContainer,
  conversationInputHeader,
  conversationInputSubheader,
  loadingLabel
};
